<template>
  <div class="list-info">
    <div class="kcjs-category" v-if="activeObj.children">
      <div class="category-item" v-for="item,ind in activeObj.children" :key="ind" :class="{active:item.title == activeCategroy }" @click="setActiveTit(item)">{{item.title}}</div>
    </div>
    <div class="kcjs-list">
      <div class="kcjs-tem" v-for="item,ind in kcjsList" :key="ind" @click="toDetail(item)">
        <div class="item-img">
          <div :style="`background-image: url(${item.cover})`"></div>
        </div>
        <div class="item-title">
          <div class="title-text">{{item.title}}</div>
        </div>
      </div>
      <div class="bnkj-empty"></div>
      <div class="bnkj-empty"></div>
      <div class="bnkj-empty"></div>
    </div>
    <div v-if="pageNum > 1" class="pagination">
      <a-pagination v-model="page" :total="total" :page-size="pageSize" @change="onPagesChange" size="small" :item-render="itemRender" />
    </div>
    <div v-else-if="kcjsList.length <= 0" class="noData-box">
      <img src="../../../../assets/image/jsckzyxy/empty.png" alt="" />
      <div class="text">暂无相关内容</div>
    </div>
    <div class="spin-con" v-if="loading">
      <a-spin>
        <a-icon slot="indicator" type="loading" style="font-size: 24px" spin />
      </a-spin>
    </div>
  </div>
</template>

<script>
import services from "../../../../assets/js/services.js";
import { mapActions } from "vuex";
import utils from "../../../../assets/js/utils.js";
export default {
  props: {
    activeObj: {
      type: Object,
      default: () => { }
    }
  },
  data() {
    return {
      school_code: localStorage.getItem("schoolCode"),
      specialId: services.KJQG_SPECIAL_ID,
      kcjsList: [],
      page: 1,
      total: 0,
      pageSize: 12,
      pageNum: 0,
      loading: false,
      activeCategroy: ""
    }
  },
  watch: {

    activeObj: {
      handler(newVal) {
        if (newVal.children) {
          this.activeCategroy = newVal.children[newVal.defaultInd].title
        } else {
          this.activeCategroy = newVal.title
        }
        this.page = 1
        this.getkjhzList()
      },
      immediate: true,

    }

  },
  methods: {
    ...mapActions(["goAppsDetailsBeforeLogin", "getAppsLoginUserInfo"]),
    async getkjhzList() {
      this.loading = true;
      let res = await services.getAreaSzztkLists({
        page: this.page,
        length: this.pageSize,
        count: 0,
        school_code: this.school_code,
        special_id: this.specialId,
        kind: "1",
        column_name: this.activeCategroy,
        order_by: "asc"
      });
      if (res.code == "0000" && res.data.items.length > 0) {
        this.kcjsList = res.data.items
        this.pageNum = res.data.page_num;
        this.total = res.data.total;
      } else {
        this.kcjsList = [];
        this.pageNum = 0;
        this.total = 0;
      }
      this.loading = false;

    },
    setActiveTit(item) {
      this.activeCategroy = item.title
      this.page = 1;
      this.getkjhzList();
    },
    onPagesChange(val) {
      this.page = val;
      this.getkjhzList();
    },
    itemRender(current, type, originalElement) {
      if (type === "prev") {
        return <a>上一页</a>;
      } else if (type === "next") {
        return <a>下一页</a>;
      }
      return originalElement;
    },
    toDetail(item) {
      if (item) {
        this.goAppsDetailsBeforeLogin().then(() => {
          if (item.is_open_url == 2) {
            window.open(`${item.source_url}`, "_blank");
          } else {
            this.$router.push({
              path: `/${this.school_code}/kjqg/detail`,
              query: {
                id: item.id,
                column_id: item.column_id,
                columnPath: "kcjsgm",
              },
            });
          }

        });
      }
    },
  }

}
</script>

<style lang="less" scoped>
.list-info {
  margin-top: -6px;
  .kcjs-category {
    display: flex;
    justify-content: center;
    margin-bottom: 32px;
    .category-item {
      font-weight: bold;
      font-size: 16px;
      color: #3a4046;
      width: 182px;
      height: 54px;
      background-image: url("../../../../assets/image/kjqg/kcjsgm/category-item.png");
      background-size: cover;
      text-align: center;
      padding-top: 15px;
      cursor: pointer;
      margin: 7px;
      &:first-child {
        margin-left: 0;
      }
      background-position: center;
      &:hover {
        color: #ffffff;
        background-image: url("../../../../assets/image/kjqg/kcjsgm/category-item-hover.png");
      }
      &.active {
        color: #ffffff;
        background-image: url("../../../../assets/image/kjqg/kcjsgm/category-item-hover.png");
      }
    }
  }
  .kcjs-list {
    display: flex;
    justify-content: space-between;
    flex-wrap: wrap;
    .kcjs-tem {
      width: 272px;
      margin-bottom: 32px;
      cursor: pointer;
      &:hover {
        .item-img {
          div {
            transform: scale(1.1);
            transition: all 0.3s;
          }
        }
        .item-title {
          .title-text {
            z-index: 11;
            position: absolute;
            overflow: unset;
            white-space: wrap !important;
            color: #1e63cb;
            width: 100%;
          }
        }
      }
      .item-img {
        width: 100%;
        height: 153px;
        border-radius: 4px 4px 0px 0px;
        overflow: hidden;
        background: #1e63cb;

        div {
          width: 100%;
          height: 100%;
          background-size: cover;
          background-position: center;
        }
      }
      .item-title {
        height: 48px;

        position: relative;
        .title-text {
          font-weight: bold;
          padding: 10px 13px 13px;
          font-size: 16px;
          color: #333333;
          line-height: 26px;
          overflow: hidden;
          text-overflow: ellipsis;
          white-space: nowrap;
          background: #ffffff;
          border-radius: 0px 0px 4px 4px;
        }
      }
    }

    .bnkj-empty {
      width: 272px;
    }
  }
  .pagination {
    display: flex;
    justify-content: center;
    align-items: center;
    position: relative;
    margin-top: 45px;
    z-index: 2;
    ::v-deep.ant-pagination {
      .ant-pagination-prev,
      .ant-pagination-next {
        margin: 0 15px;
        a {
          color: #1869e4;
        }
      }
      .ant-pagination-item {
        margin: 0 5px;
        border-radius: 0;
        a {
          color: #1869e4;
        }
        &.ant-pagination-item-active {
          background-color: #1869e4;
          border: 1px solid transparent;
          a {
            color: #fff;
          }
        }
      }
    }
  }
}
.spin-con {
  position: fixed;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.3);
  top: 0;
  z-index: 999;
  left: 0;
  display: flex;
  justify-content: center;
  align-items: center;
}
</style>